import { FormControl, FormLabel, Grid, Input, Stack, Typography } from '@mui/joy';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';
import { AdminLevelsTable } from '@/components/admin-levels/table/AdminLevelsTable';
import { OrganizationAdminLevelsTable } from '@/components/organizations/table/OrganizationAdminLevelsTable';
import { ButtonLink } from '@/components/router/ButtonLink';
import { I18N_DE } from '@/i18n/de';
import { backendApiAdminLevelsFindOneOptions } from '@/modules/api/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/_management/administration/verwaltungsebenen/$adminLevelId/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AdminLevelDetailsRoute,
});

function AdminLevelDetailsRoute() {
  const { adminLevelId } = Route.useParams();

  const { data, isFetching } = useQuery(
    backendApiAdminLevelsFindOneOptions({ path: { adminLevelId }, query: { organizations: true, children: true } }),
  );

  return (
    <ContainerLayout>
      <Grid container spacing={4}>
        <Grid md={6}>
          <Stack gap={2}>
            <Typography level="h3">Verwaltungsebene</Typography>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input value={data?.name ?? ''} readOnly />
            </FormControl>
            <FormControl>
              <FormLabel>Ebene</FormLabel>
              <Input value={(data && I18N_DE.AdminLevelType[data.type]) ?? ''} readOnly />
            </FormControl>
            <FormControl>
              <FormLabel>Amtlicher Regionalschlüssel (ARS)</FormLabel>
              <Input value={data?.regionalCode ?? ''} readOnly />
            </FormControl>
          </Stack>
        </Grid>

        <Grid md={6}>
          <Typography level="h3" marginBottom={6}>
            Untergeordnete Verwaltungsebenen
          </Typography>
          <AdminLevelsTable data={data?.children} isFetching={isFetching} />

          <Stack direction="row" justifyContent="space-between" marginBottom={4} marginTop={6}>
            <Typography level="h3">Zugeordnete Organisationen</Typography>

            <ButtonLink from="/administration/verwaltungsebenen/$adminLevelId/" to="organisationen/hinzufuegen">
              Hinzufügen
            </ButtonLink>
          </Stack>
          <OrganizationAdminLevelsTable data={data?.organizations} isFetching={isFetching} show="organizations" />
        </Grid>
      </Grid>
    </ContainerLayout>
  );
}
